import React from 'react';
import { type ButtonProps } from 'antd';
import * as S from './styles';

interface GhostButtonProps extends ButtonProps {
	children: JSX.Element;
}

export const GhostButton = ({ children, ...props }: Readonly<GhostButtonProps>) => {
	return (
		<S.GhostButton {...props} type="ghost">
			{children}
		</S.GhostButton>
	);
};
